
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { PlexEnvironment } from '@app/env';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { State } from '@progress/kendo-data-query';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class ProjectResourceGridService extends BehaviorSubject<GridDataResult> {
  private http = inject(HttpClient);
  public environment = inject(PlexEnvironment);

  private BASE_URL = this.environment.apiUrl;
  private tableName: string = 'ProjectResourceItems';
  private expandTerm: string = '?$expand=UnitOfMeasure%2C%20CostCodeCostType(%24expand%3DCostCode%2C%20CostType)';

  public state: State = {
    skip: 0,
    take: 5
  };

  constructor() {
    super(null);
  }

  private fetch(tableName: string, state: any): Observable<GridDataResult> {
    return this.http
      .get(`${this.BASE_URL}${tableName}${this.expandTerm}`).pipe(
        map(response => response),
        map((response: any) => {
          return <GridDataResult>{
            data: response.value,
            total: parseInt(response['@odata.count'], 10)
          };
        }),);
  }

  private create(Item: any) {
    Item.ProjectResourceItemId = 0;
    let url = `${this.BASE_URL}${this.tableName}`;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http
      .post(url, Item, { headers: headers })
      .toPromise();
  }

  public save(data: any, isNew?: boolean) {
    if (isNew) {
      return this.create(data);
    } else {
      return this.update(data);
    }
  }

  public query(state: any): void {
    this.fetch(this.tableName, state)
      .subscribe(x => super.next(x));
  }

  public update(Item: any) {
    let url = `${this.BASE_URL}${this.tableName}(${Item.ProjectResourceItemId})`;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let updateItem: any = {
      Quantity: Item.Quantity,
      Rate: Item.Rate,
      ExtendedValue: Item.Quantity * Item.Rate,
      Phase: Item.Phase,
      Step: Item.Step
    };
    return this.http
      .patch(url, updateItem, { headers: headers })
      .toPromise();
  }

  public remove(Item: any) {
    let url = `${this.BASE_URL}${this.tableName}?ProjectResourceItemId=${Item.ProjectResourceItemId}`;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http
      .delete(url, { headers: headers }).toPromise();
  }

  public updateCcct(Item: any) {
    let tableName = 'ProjectCostCodeCostTypeItems';
    let url = `${this.BASE_URL}${tableName}(${Item.ProjectCostCodeCostTypeItemId})`;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let updateItem: any = {
      ExtendedValue: Item.Quantity * Item.Rate,
      Quantity: Item.Quantity,
      Rate: Item.Rate,
      Phase: Item.Phase,
      Step: Item.Step
    };
    return this.http
      .patch(url, updateItem, { headers: headers })
      .toPromise();
  }

  public removeCcct(Item: any) {
    let tableName = 'ProjectCostCodeCostTypeItems';
    let url = `${this.BASE_URL}${tableName}?ProjectCostCodeCostTypeItemId=${Item.ProjectCostCodeCostTypeItemId}`;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http
      .delete(url, { headers: headers }).toPromise();
  }

  public assignCcctValues(target: any, source: any): void {
    Object.assign(target, source);
    target.Rate = target.ExtendedValue;
    target.Quantity = 1;
  }

  public assignValues(target: any, source: any): void {
    Object.assign(target, source);
  }
}